import { ArrowUpRight, MapPin } from "lucide-react";

export const Hero = ({ t }) => {
  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section
      id="home"
      data-testid="hero-section"
      className="relative pt-32 md:pt-36 pb-20 md:pb-32 overflow-hidden"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-center">
          {/* Left content */}
          <div className="lg:col-span-7">
            <div className="reveal flex items-center gap-3 mb-8">
              <span className="w-10 h-px bg-[#183321]/40" />
              <span className="text-xs uppercase tracking-[0.25em] text-[#4A6B53] font-semibold">
                {t.hero.eyebrow}
              </span>
            </div>

            <h1 className="font-serif text-5xl sm:text-6xl md:text-7xl lg:text-[5.5rem] leading-[0.95] tracking-tight text-[#183321] font-medium">
              <span className="reveal block">{t.hero.title_1}</span>
              <span className="reveal reveal-delay-1 block italic text-[#2A4D35]">
                {t.hero.title_2}
              </span>
              <span className="reveal reveal-delay-2 block">
                {t.hero.title_3}
                <span className="text-[#C26D5C]">.</span>
              </span>
            </h1>

            <p className="reveal reveal-delay-3 mt-10 max-w-xl text-base md:text-lg leading-relaxed text-[#4A6B53]">
              {t.hero.lede}
            </p>

            <div className="reveal reveal-delay-3 mt-10 flex flex-col sm:flex-row gap-4">
              <button
                data-testid="hero-cta-primary"
                onClick={() => scrollTo("contact")}
                className="group inline-flex items-center justify-center gap-2 px-7 py-4 bg-[#2A4D35] text-[#FDFDF9] text-sm uppercase tracking-widest font-semibold rounded-sm hover:bg-[#3C664A] hover:-translate-y-0.5 transition-all"
              >
                {t.hero.cta_primary}
                <ArrowUpRight
                  size={18}
                  className="group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform"
                />
              </button>
              <button
                data-testid="hero-cta-secondary"
                onClick={() => scrollTo("services")}
                className="inline-flex items-center justify-center gap-2 px-7 py-4 border border-[#183321]/30 text-[#183321] text-sm uppercase tracking-widest font-semibold rounded-sm hover:bg-[#183321] hover:text-[#FDFDF9] transition-all"
              >
                {t.hero.cta_secondary}
              </button>
            </div>

            <div className="reveal reveal-delay-3 mt-14 flex flex-wrap gap-x-10 gap-y-4 text-sm text-[#4A6B53]">
              <div className="flex items-center gap-2">
                <span className="w-2 h-2 rounded-full bg-[#2A4D35]" />
                {t.hero.meta_a}
              </div>
              <div className="flex items-center gap-2">
                <MapPin size={14} className="text-[#C26D5C]" />
                Miami, FL
              </div>
              <div className="flex items-center gap-2">
                <span className="w-2 h-2 rounded-full bg-[#C26D5C]" />
                {t.hero.meta_b}
              </div>
            </div>
          </div>

          {/* Right image — Official business card */}
          <div className="lg:col-span-5 relative">
            <div
              data-testid="hero-card-frame"
              className="reveal reveal-delay-2 relative bg-[#FDFDF9] border border-[#183321]/10 rounded-sm p-4 md:p-5 shadow-[0_30px_60px_-30px_rgba(24,51,33,0.35)]"
            >
              <div className="absolute -top-3 left-6 px-3 py-1 bg-[#2A4D35] text-[#FDFDF9] text-[10px] uppercase tracking-[0.25em] font-semibold rounded-sm">
                Josengineer · Corp
              </div>
              <img
                data-testid="hero-business-card"
                src="https://customer-assets.emergentagent.com/job_civil-testing-lab/artifacts/t1qkwvfs_CARDFweb.gif"
                alt="Josengineer Corp business card — Jose Arturo Salas"
                className="w-full h-auto object-contain rounded-sm"
                loading="eager"
              />
              <div className="mt-4 px-2 pb-2 flex items-center justify-between text-xs text-[#4A6B53]">
                <span className="uppercase tracking-[0.2em] font-semibold">
                  AutoCAD & Engineering
                </span>
                <span className="italic">Se habla español</span>
              </div>
            </div>

            {/* Floating stat */}
            <div className="reveal reveal-delay-3 absolute -bottom-10 -right-4 hidden md:block bg-[#2A4D35] text-[#FDFDF9] border border-[#183321]/10 rounded-sm p-6 max-w-[200px]">
              <div className="font-serif text-5xl leading-none">
                10<span className="text-[#C26D5C]">+</span>
              </div>
              <div className="mt-3 text-xs uppercase tracking-widest text-[#FDFDF9]/80">
                Years building South Florida
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
